// SyncedStore setup for Todo functionality
import { syncedStore } from '@syncedstore/core'
import { initializeDoc } from './connection'
import { setStore as setTodoStore } from './operations'
import type { Todo, WorkerOut, WorkerAssignment, Location, WorkerAssignmentLog, WorkerTimeLog, Team, Worker, Zone, TaskType } from './types'

// Create the synced store
export const todoStore = syncedStore({
  todos: [] as Todo[],
  workerOuts: [] as WorkerOut[],
  workerAssignments: [] as WorkerAssignment[],
  workerAssignmentLogs: [] as WorkerAssignmentLog[],
  workerTimeLogs: [] as WorkerTimeLog[],
  locations: [] as Location[],
  zones: [] as Zone[],
  teams: [] as Team[],
  workers: [] as Worker[],
  taskTypes: [] as TaskType[],
})

// Initialize the document and set store references
initializeDoc(todoStore)
setTodoStore(todoStore)

// Re-export everything from connection, operations, awareness and types
export * from './connection'
export * from './operations'
export * from './awareness'
export * from './types'
